















































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { mdbAlert, mdbBtn, mdbIcon, mdbTooltip, mdbRow, mdbCol, mdbCard, mdbCardBody, mdbCardTitle, mdbTbl, mdbTblBody, mdbPopover, mdbSelect } from '@folky-tools/mdbvue';
import { BusinessFrontPage } from '@/models/businesses/business-front-page';
import { BusinessFrontPageSummary } from '@/models/businesses/business-front-page-summary';
import { ContactDetails } from '@/models/common/contact-details';
import {
    usersService,
    businessesService,
    businessFrontPagesService,
    notificationsService,
    updateOrganizationBusinessExternalLinks,
    UpdateOrganizationBusinessExternalLinksDto,
    UpdateOrganizationBusinessExternalLinksLinkDto,
    updateOrganizationBusinessLogo,
    UpdateOrganizationBusinessLogoDto,
    getOrganizationBusinessFrontPageSummaryByBusinessId
} from '@/services';
import { UserActionLogInfo } from '@/models/users/user-logging/user-action-log-info';
import { UserActionType } from '@/models/users/user-logging/user-action-type';
import { UserActionEntityType } from '@/models/users/user-logging/user-action-entity-type';
import { UserActionScopeType } from '@/models/users/user-logging/user-action-scope-type';
import { Business } from '@/models/businesses/business';
import { Link, LinkType } from '@/models/common/link';
import { gmaps } from '@/plugins/gmaps';
import { Consumer } from '@/models/consumers/consumer';
import Swal from 'sweetalert2';

@Component({
    components: {
        mdbAlert,
        mdbBtn,
        mdbIcon,
        mdbTooltip,
        mdbRow,
        mdbCol,
        mdbCard,
        mdbCardBody,
        mdbCardTitle,
        mdbTbl,
        mdbTblBody,
        mdbPopover,
        mdbSelect,
        FormModal: () => import('@/components/shared/FormModal.vue'),
        BusinessBasicData: () => import('@/components/businesses/BusinessBasicData.vue'),
        BusinessProjectData: () => import('@/components/businesses/BusinessProjectData.vue'),
        FileUpload: () => import('@/components/shared/FileUpload.vue'),
        Wysiwyg: () => import('@/components/shared/Wysiwyg.vue'),
        EditContactDetails: () => import('@/components/shared/EditContactDetails.vue'),
        EditOpeningHours: () => import('@/components/shared/EditOpeningHours.vue'),
        EditSocialMediaLinks: () => import('@/components/shared/EditSocialMediaLinks.vue'),
        AppSysBar: () => import('@/components/shared/AppSysBar.vue')
    }
})
export default class BusinessBasicDataView extends Vue {
    private businessFrontPage: BusinessFrontPage = new BusinessFrontPage();
    private businessFrontPageSummary: BusinessFrontPageSummary | null = null;
    private frontPageDescription?: string = '';
    private contactDetails: ContactDetails = new ContactDetails();
    private business: Business = new Business();
    private businessCopy: Business = new Business();
    private externalLinks: Link[] = [];
    private consumers: Consumer[] = [];

    private showEditFrontPageLogo: boolean = false;
    private showEditFrontPageDescription: boolean = false;
    private showEditFrontPageContactDetails: boolean = false;
    private showEditBasicData: boolean = false;
    private selectedProjectId: number | null = null;
    private showEditProjectData: boolean = false;
    private showEditFrontPageSocialMediaLinks: boolean = false;

    private savingFrontPageLogo: boolean = false;
    private savingFrontPageDescription: boolean = false;
    private savingFrontPageContactDetails: boolean = false;
    private savingBasicData: boolean = false;
    private savingProjectData: boolean = false;
    private savingCanonicalConsumer: boolean = false;
    private savingFrontPageSocialMediaLinks: boolean = false;

    private invalidDataInFrontPageContactDetails: boolean = false;
    private pageContentLoaded: boolean = false;

    // #region GENERIC

    @Watch('business.tradeName')
    private onBusinessTradeNameChanged(): void {
        this.$root.$emit('change-active-page', 'views.businesses.businessBasicData.title', this.business.tradeName ? this.business.tradeName : '...');
    }

    get externalLinksWithValue() {
        return this.externalLinks.filter(l => l.url);
    }

    get logoUrl(): string {
        if (this.business.logoUrl) {
            return this.business.logoUrl;
        } else {
            const imagesContext = require.context('@/assets/placeholders/business/', false, /(\.jpg|\.png)$/);
            return imagesContext('./whiteBrandLogoDark.png');
        }
    }

    private async mounted(): Promise<void> {
        this.$root.$emit('change-active-page', 'views.businesses.businessBasicData.title', '...');

        const businessFrontPage = await businessFrontPagesService.getBusinessFrontPage(+this.$route.params.id);
        if (businessFrontPage) {
            this.businessFrontPage = businessFrontPage;
        }

        this.frontPageDescription = this.businessFrontPage.description;
        this.contactDetails = new ContactDetails();
        if (this.businessFrontPage.contactDetails) {
            this.contactDetails = this.businessFrontPage.contactDetails.clone();
        }

        this.business = await businessesService.getBusiness(+this.$route.params.id);
        this.businessCopy = this.business.clone();

        this.resetAvailableConsumers();

        this.business.externalLinks.forEach(link => {
            if (link.type !== LinkType.Other) {
                this.externalLinks.push(link.clone());
            }
        });

        this.$root.$emit('change-active-page', 'views.businesses.businessBasicData.title', this.business.tradeName ? this.business.tradeName : '...');

        await usersService.logUserAction(
            new UserActionLogInfo({
                type: UserActionType.HasVisited,
                entity: UserActionEntityType.Businesses,
                scope: UserActionScopeType.BasicData,
                entityId: this.business.id
            })
        );
        setTimeout(() => this.switchPageContentToLoaded(), 600);
    }

    private switchPageContentToLoaded() {
        this.pageContentLoaded = true;
    }

    private async resetAvailableConsumers(): Promise<void> {
        this.businessFrontPageSummary = new BusinessFrontPageSummary(await getOrganizationBusinessFrontPageSummaryByBusinessId.execute(+this.$route.params.id));
        if (this.businessFrontPageSummary && this.businessFrontPageSummary.publicationStatus && this.businessFrontPageSummary.publicationStatus.length) {
            this.consumers = [];
            this.businessFrontPageSummary.publicationStatus.forEach(c => {
                if (c.isPublished) {
                    this.consumers.push(
                        new Consumer({
                            id: c.consumerId,
                            name: c.consumerName,
                            selected: c.isCanonical,
                            disabled: false
                        })
                    );
                }
            });
        }
    }

    // #endregion GENERIC

    // #region EDIT LOGO

    private editFrontPageLogo(): void {
        this.showEditFrontPageLogo = true;
    }

    private async saveFrontPageLogo(): Promise<void> {
        this.savingFrontPageLogo = true;

        try {
            const logoFile: File = (this.$refs.editFrontPageLogo as any).getFinalImageFile();
            if (logoFile) {
                this.business.logoUrl = await updateOrganizationBusinessLogo.execute(new UpdateOrganizationBusinessLogoDto(this.business.id, logoFile));
                this.businessCopy.logoUrl = this.business.logoUrl;

                notificationsService.showToastSuccessNotification('views.businesses.businessBasicData.notifications.logoUpdated');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.Logo,
                        entityId: this.business.id
                    })
                );
            }

            this.closeFrontPageLogoEdition();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageLogo = false;
        }
    }

    private async closeFrontPageLogoEdition(): Promise<void> {
        this.business = await businessesService.getBusiness(+this.$route.params.id);
        this.showEditFrontPageLogo = false;
    }

    // #endregion EDIT LOGO

    // #region EDIT DESCRIPTION

    private editFrontPageDescription(): void {
        this.showEditFrontPageDescription = true;
    }
    private onUpdateFrontPageDescription(htmlContent: string): void {
        this.frontPageDescription = htmlContent;
    }
    private async saveFrontPageDescription(): Promise<void> {
        this.savingFrontPageDescription = true;
        try {
            if (this.businessFrontPage.description !== this.frontPageDescription) {
                if (await businessFrontPagesService.updateBusinessFrontPageDescription(+this.$route.params.id, this.frontPageDescription!)) {
                    this.businessFrontPage.description = this.frontPageDescription;
                    this.closeFrontPageDescriptionEdition();

                    notificationsService.showToastSuccessNotification('views.businesses.businessBasicData.notifications.descriptionUpdated');

                    await usersService.logUserAction(
                        new UserActionLogInfo({
                            type: UserActionType.HasChanged,
                            entity: UserActionEntityType.Businesses,
                            scope: UserActionScopeType.Description,
                            entityId: this.business.id
                        })
                    );

                    return;
                }

                notificationsService.showToastErrorNotification();
                return;
            }
            this.closeFrontPageDescriptionEdition();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageDescription = false;
        }
    }
    private closeFrontPageDescriptionEdition(): void {
        this.frontPageDescription = this.businessFrontPage.description;
        this.showEditFrontPageDescription = false;
    }

    // #endregion EDIT DESCRIPTION

    // #region EDIT CONTACT DETAILS

    private editFrontPageContactDetails(): void {
        this.showEditFrontPageContactDetails = true;
    }
    private async saveFrontPageContactDetails(): Promise<void> {
        this.savingFrontPageContactDetails = true;

        if ((this.$refs.editContactDetails as any).hasErrors()) {
            this.savingFrontPageContactDetails = false;
            this.invalidDataInFrontPageContactDetails = true;
            return;
        }
        this.invalidDataInFrontPageContactDetails = false;

        await gmaps.setAddressLocation(this.contactDetails.address);
        try {
            if (await businessFrontPagesService.updateBusinessFrontPageContactDetails(+this.$route.params.id, this.contactDetails)) {
                this.businessFrontPage.contactDetails = this.contactDetails.clone();
                this.closeFrontPageContactDetailsEdition();

                notificationsService.showToastSuccessNotification('views.businesses.businessBasicData.notifications.contactDetailsUpdated');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.ContactData,
                        entityId: this.business.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageContactDetails = false;
        }
    }
    private closeFrontPageContactDetailsEdition(): void {
        this.contactDetails = this.businessFrontPage.contactDetails.clone();
        this.showEditFrontPageContactDetails = false;
    }

    // #endregion EDIT CONTACT DETAILS

    // #region EDIT BASIC DATA

    private editBusinessBasicData(): void {
        this.showEditBasicData = true;
    }
    private async saveBusinessBasicData(): Promise<void> {
        this.savingBasicData = true;

        if ((this.$refs.businessBasicData as any).hasErrors()) {
            this.savingBasicData = false;
            return;
        }

        try {
            if (await businessesService.updateBusinessBasicData(this.business)) {
                this.businessCopy = this.business.clone();
                this.showEditBasicData = false;

                notificationsService.showToastSuccessNotification('views.businesses.businessDashboardView.editBasicData.save.successMessage');

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.BasicData,
                        entityId: this.business.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingBasicData = false;
        }
    }
    private closeBusinessBasicDataEdition(): void {
        this.business = this.businessCopy.clone();
        this.showEditBasicData = false;
    }

    // #endregion EDIT BASIC DATA

    // #region EDIT BUSINESS CANONICAL CONSUMER

    private async onChangeConsumer(value: number, text: string): Promise<void> {
        if (
            this.businessFrontPageSummary &&
            this.businessFrontPageSummary.publicationStatus &&
            this.businessFrontPageSummary.publicationStatus.length &&
            (!this.businessFrontPageSummary.publicationStatus.some(c => c.isCanonical) || value !== this.businessFrontPageSummary.publicationStatus.find(c => c.isCanonical)!.consumerId)
        ) {
            const questionResult = await Swal.fire({
                title: this.$t('views.businesses.businessBasicData.editCanonicalConsumer.authorizationModal.title').toString(),
                html: this.$t('views.businesses.businessBasicData.editCanonicalConsumer.authorizationModal.html').toString().replace('{0}', text),
                type: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('views.businesses.businessBasicData.editCanonicalConsumer.authorizationModal.confirmButtonText').toString(),
                cancelButtonText: this.$t('views.businesses.businessBasicData.editCanonicalConsumer.authorizationModal.cancelButtonText').toString(),
                customClass: {
                    confirmButton: 'btn btn-primary',
                    cancelButton: 'btn btn-danger'
                },
                animation: false
            });
            if (questionResult.value) {
                this.savingCanonicalConsumer = true;
                try {
                    if (await businessesService.updateBusinessCanonicalConsumer(+this.$route.params.id, value)) {
                        notificationsService.showToastSuccessNotification('views.businesses.businessBasicData.notifications.canonicalConsumerUpdated');

                        this.resetAvailableConsumers();
                        this.$root.$emit('change-business-frontpage-summary', this.businessFrontPageSummary);

                        await usersService.logUserAction(
                            new UserActionLogInfo({
                                type: UserActionType.HasChanged,
                                entity: UserActionEntityType.Businesses,
                                scope: UserActionScopeType.CanonicalConsumer,
                                entityId: this.business.id
                            })
                        );
                    } else {
                        this.resetAvailableConsumers();
                        notificationsService.showToastErrorNotification();
                    }
                } catch {
                    this.resetAvailableConsumers();
                    notificationsService.showToastErrorNotification();
                } finally {
                    this.savingCanonicalConsumer = false;
                }
            } else {
                this.resetAvailableConsumers();
            }
        }
    }

    // #endregion EDIT BUSINESS CANONICAL CONSUMER

    // #region EDIT PROJECT DATA

    private addBusinessProjectData(): void {
        this.selectedProjectId = 0;
        this.showEditProjectData = true;
    }

    private editBusinessProjectData(projectId: number): void {
        this.selectedProjectId = projectId;
        this.showEditProjectData = true;
    }

    private async saveBusinessProjectData(): Promise<void> {
        this.savingProjectData = true;

        if ((this.$refs.businessProjectData as any).hasErrors()) {
            this.savingProjectData = false;
            return;
        }

        try {
            if (await businessesService.updateBusinessProjects(this.business)) {
                this.businessCopy = this.business.clone();
                this.showEditProjectData = false;

                notificationsService.showToastSuccessNotification('views.businesses.businessDashboardView.editProjectData.save.successMessage');
                this.resetAvailableConsumers();

                await usersService.logUserAction(
                    new UserActionLogInfo({
                        type: UserActionType.HasChanged,
                        entity: UserActionEntityType.Businesses,
                        scope: UserActionScopeType.ProjectData,
                        entityId: this.business.id
                    })
                );

                return;
            }
            notificationsService.showToastErrorNotification();
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingProjectData = false;
        }
    }

    private closeBusinessProjectDataEdition(): void {
        this.business = this.businessCopy.clone();
        this.showEditProjectData = false;
    }

    // #endregion EDIT PROJECT DATA

    // #region EDIT EXTERNAL LINKS

    private editFrontPageSocialMediaLinks(): void {
        this.showEditFrontPageSocialMediaLinks = true;
    }

    private async saveFrontPageSocialMediaLinks(): Promise<void> {
        this.savingFrontPageSocialMediaLinks = true;

        if ((this.$refs.editSocialMediaLinks as any).hasErrors()) {
            this.savingFrontPageSocialMediaLinks = false;
            return;
        }

        try {
            await updateOrganizationBusinessExternalLinks.execute(
                new UpdateOrganizationBusinessExternalLinksDto(
                    +this.$route.params.id,
                    this.externalLinks.map((l: Link) => new UpdateOrganizationBusinessExternalLinksLinkDto(l.title!, l.url!, l.type!))
                )
            );
            this.business.externalLinks = [];
            this.externalLinks.forEach(link => {
                this.business.externalLinks.push(link.clone());
            });
            this.closeFrontPageSocialMediaLinksEdition();

            notificationsService.showToastSuccessNotification('views.businesses.businessBasicData.notifications.socialLinksUpdated');

            await usersService.logUserAction(
                new UserActionLogInfo({
                    type: UserActionType.HasChanged,
                    entity: UserActionEntityType.Businesses,
                    scope: UserActionScopeType.SocialMediaLinks,
                    entityId: this.business.id
                })
            );
        } catch {
            notificationsService.showToastErrorNotification();
        } finally {
            this.savingFrontPageSocialMediaLinks = false;
        }
    }

    private closeFrontPageSocialMediaLinksEdition(): void {
        this.externalLinks = [];
        this.business.externalLinks.forEach(link => {
            if (link.type !== LinkType.Other) {
                this.externalLinks.push(link.clone());
            }
        });
        this.showEditFrontPageSocialMediaLinks = false;
    }

    // #endregion EDIT EXTERNAL LINKS
}
